import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmPopupComponent } from './../confirm-popup/confirm-popup.component';
import { PageTitleService } from './../../core';
import {
    MatSnackBar,
    MatSnackBarHorizontalPosition,
    MatSnackBarVerticalPosition,
  } from '@angular/material/snack-bar';


@Injectable({
    providedIn: 'root'
})
export class MessageService {
    private readonly dialog = inject(MatDialog);
    private readonly pageTitle = inject(PageTitleService);
    private readonly snackBar = inject(MatSnackBar);


    public displayTime = 5000;
    public horizontalPosition: MatSnackBarHorizontalPosition = "right";
    public verticalPosition:MatSnackBarVerticalPosition = "top";

    /* #region Public Methods */
    /** This method is being used to show Confirmation Pop up */
    public confirm(message: string, title: string, confirmLable = 'Common.Button.Yes',
        cancelLabel = 'Common.Button.No',isOkButton=true): Observable<boolean> {
        const dialogRef = this.dialog.open(ConfirmPopupComponent, {
            width: '500px',
            minHeight: '220px',
            maxHeight: '320px',
            data: { message, title, confirmLable, cancelLabel,isOkButton },
            autoFocus: false,
            disableClose: true
        });
        return dialogRef.afterClosed();
    }

    /** This method is being used to display a Primary toast messsage */
    public primary(message: string, displayTime = this.displayTime): void {
      this.snackBar.open(message,"", {horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition, duration: displayTime,panelClass: "primary-content"
      });
    }

    /** This method is being used to display a Warning toast messsage */
    public warning(message: string, displayTime = this.displayTime): void {
      this.snackBar.open(message,"", {horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition, duration: displayTime,panelClass: "warning-content"
      });
    }

    /** This method is being used to display a Success toast messsage */
    public success(message: string, displayTime = this.displayTime): void {
      this.snackBar.open(message,"", {horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition, duration: displayTime,panelClass: "success-content"
      });
    }

    /** This method is being used to display a Alert toast messsage */
    public alert(message: string, displayTime = this.displayTime): void {
      this.snackBar.open(message,"", {horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition, duration: displayTime,panelClass: "error-content"
      });
    }

    /** This method is being used to set Page title in Toolbar */
    public setPageTitle(title: string, subTitle = ''): void {
        this.pageTitle.setPageTitle([title, subTitle]);
    }
}
